
import { defineComponent, PropType } from "vue";

import ResourceIcon from "@/components/Elements/ResourceIcon.vue";

import Resource from "@/models/Resource";

export default defineComponent({
  props: {
    resource: { type: String as PropType<Resource> },
    disabled: { type: Boolean, default: false },
    noIcon: { type: Boolean, default: false },
  },
  components: { ResourceIcon },
});
